export enum Color {
    BLUE = '#0074E4'
}

export default Color;
